// THIS IS AN AUTOGENERATED FILE.  DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'styled-components';
import { useIconSize } from '../useIconSize';
import { jsx as _jsx } from "react/jsx-runtime";
export const VideoFileIcon = ({
  size = 'inherit',
  color = 'inherit',
  'aria-label': ariaLabel,
  id
}) => {
  const theme = useTheme();
  const sizeValue = useIconSize(size);
  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // currentColor = color of the parent element

  return /*#__PURE__*/_jsx("svg", {
    width: sizeValue,
    height: sizeValue,
    fill: colorValue,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "VideoFile",
    children: /*#__PURE__*/_jsx("path", {
      d: "M30.03 10.54a2 2 0 0 0-.12-.35s0-.07 0-.07c-.07-.12-.15-.21-.24-.3L22.15 2.3c-.08-.07-.18-.14-.29-.19s-.08 0-.08 0c-.08-.04-.17-.07-.27-.1s-9.72 0-9.72 0a4.22 4.22 0 0 0-4.22 4.12v3.42c-3.23.68-5.63 3.5-5.63 6.89s2.39 6.21 5.58 6.88h.05v2.94c0 2.21 1.74 3.75 4.22 3.75h14.06c2.48 0 4.22-1.54 4.22-3.75V10.54h-.03ZM6.62 12.93l.98.54 5.63 3.24-2.85 1.63-2.81 1.63-.98.54.04-7.58Zm20.63 13.35c0 .77-.76.98-1.41.98H11.78c-.64 0-1.41-.17-1.41-.98v-2.93c3.23-.68 5.63-3.5 5.63-6.89s-2.39-6.21-5.58-6.88h-.05V6.12c0-.78.63-1.41 1.41-1.41h7.97v5.16c0 1.29 1.05 2.34 2.34 2.34h5.16v14.06Z"
    })
  });
};